import {
  CHANGE_GROUP,
  LOAD_MORE,
  UPDATE_BOND_INVESTORS,
  UPDATE_ESTIMATES,
  UPDATE_EVENTS,
  UPDATE_FUNDAMENTAL_CHARTS,
  UPDATE_HIGH_CONVICTION,
  UPDATE_PRICES,
  UPDATE_TICKERS_IN_PORTFOLIO,
  UPDATE_TICKERS_IN_UNIVERSAL,
  PORTFOLIO_DATA,
  SET_LOADING,
  CURRENT_SCROLL_POSITION,
  SET_BOTTOM,
  SET_COMPANIES,
  CLEAN_UP,
  CHANGE_SEARCH_INPUT_VALUE,
  CHANGE_RISK_STATUS,
  CHANGE_SECTOR,
  CHANGE_COUNTRY,
  CHANGE_REGION,
  CHANGE_SELECTED_TAB,
  UPDATE_EVENTS_LOADING,
  UPDATE_PRICE_LOADING,
  UPDATE_FUNDAMENTAL_LOADING,
  SET_ACTIVE_NODE,
  SET_SHOW_BEHAVIOURAL,
  SET_SHOW_PEER_TOGGLE,
  SET_SHOW_COMPANY_TOGGLE,
  REMOVE_COMPANY,
  UPDATE_CREDIT_PANEL_DATA,
  UPDATE_CREDIT_PANEL_LOADING,
  UPDATE_BEHAVIOR_CHART_LOADING,
  UPDATE_SHOW_BEHAVIOUR_CHART,
  CHANGE_IMPLIED_RATING,
  CHANGE_SELECTED_RISK_TAB,
  SET_EXISTED_CREDIT_RISK,
  CHANGE_CREDIT_RISK_STATUS,
  UPDATE_CREDIT_DATA_COMPARISON,
  DELETE_CREDIT_DATA_COMPARISON,
  UPDATE_NOTES_LOADING,
  UPDATE_NOTES_DATA,
  GET_WHAT_IF_LOADING,
  GET_WHAT_IF_DATA,
  CALCULATE_WHAT_IF_LOADING,
  CALCULATE_WHAT_IF_DATA,
  CLEAR_CALCULATE_WHAT_IF_DATA,
  UPDATE_PRICES_CURRENCY,
  CHANGE_INDUSTRY,
  SET_LOADING_ADD_DELETE_TICKER,
} from './portfolio.constants'
import {
  deleteItemPodCompare,
  mergeEquityPrice,
  mergePodCompare,
} from '../../ultils/dataUtil'
import { RISK_TYPE } from '../../ultils/chart-d3-utils'

export const initialState = {
  groupFilter: 'none',
  loadMore: 0,
  tickersInPortfolio: [],
  tickersInUniverse: [],
  companies: [],
  marketContext: {
    priceLoading: true,
    eventLoading: true,
    priceData: [],
    eventData: [],
    currency: null,
  },
  fundamentalData: [],
  fundamentalLoading: true,
  behaviorData: {
    estimates: [],
    bondInvestors: [],
    highConvictions: [],
  },
  creditData: {
    pod: [],
    driver: [],
    impliedRating: [],
    podCompare: {},
  },
  creditLoading: true,
  behaviorChartLoading: true,
  portfolioData: [],
  loading: true,
  loadingAddDeleteTicker: false,
  currentScrollPosition: 0,
  bottom: false,
  filterState: {
    searchByWord: '',
    impliedRating: [],
    riskStatus: [],
    creditRiskStatus: [],
    sector: [],
    industry: [],
    country: [],
    region: [],
  },
  selectedTab: 0,
  selectedRiskTypeTab: RISK_TYPE.EQUITY,
  activeNode: null,
  creditRiskDataExisted: true,
  showFundamentals: true,
  showBehavioural: true,
  showCreditChart: true,
  showPeerToggle: false,
  showCompanyToggle: false,
  notesDataLoading: true,
  notesData: {},
  whatIfLoading: false,
  whatIfCalculateLoading: false,
  whatIfData: {},
  whatIfDataDetail: {},
  whatIfDataDetailCalculate: {},
}

export const portfolioReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case CHANGE_SEARCH_INPUT_VALUE:
      return {
        ...state,
        filterState: { ...state.filterState, searchByWord: action.payload },
      }
    case CHANGE_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      }
    case CHANGE_SELECTED_RISK_TAB:
      return {
        ...state,
        selectedRiskTypeTab: action.payload,
      }
    case SET_EXISTED_CREDIT_RISK:
      return {
        ...state,
        creditRiskDataExisted: action.payload,
      }
    case CHANGE_IMPLIED_RATING:
      return {
        ...state,
        filterState: { ...state.filterState, impliedRating: action.payload },
      }
    case CHANGE_RISK_STATUS:
      return {
        ...state,
        filterState: { ...state.filterState, riskStatus: action.payload },
      }
    case CHANGE_CREDIT_RISK_STATUS:
      return {
        ...state,
        filterState: { ...state.filterState, creditRiskStatus: action.payload },
      }
    case CHANGE_SECTOR:
      return {
        ...state,
        filterState: { ...state.filterState, sector: action.payload },
      }
    case CHANGE_INDUSTRY:
      return {
        ...state,
        filterState: { ...state.filterState, industry: action.payload },
      }
    case CHANGE_COUNTRY:
      return {
        ...state,
        filterState: { ...state.filterState, country: action.payload },
      }
    case CHANGE_REGION:
      return {
        ...state,
        filterState: { ...state.filterState, region: action.payload },
      }
    case CHANGE_GROUP:
      return {
        ...state,
        groupFilter: action.payload,
      }
    case SET_ACTIVE_NODE:
      return {
        ...state,
        activeNode: action.payload,
      }
    case LOAD_MORE:
      return {
        ...state,
        loadMore: action.payload,
      }
    case UPDATE_TICKERS_IN_PORTFOLIO:
      return {
        ...state,
        tickersInPortfolio: action.payload,
      }
    case UPDATE_TICKERS_IN_UNIVERSAL:
      return {
        ...state,
        tickersInUniverse: action.payload,
      }
    case UPDATE_PRICES:
      return {
        ...state,
        marketContext: {
          ...state.marketContext,
          priceData: action.payload,
          // priceLoading: false,
        },
        creditData: {
          pod: mergeEquityPrice(action.payload, state.creditData.pod ?? []),
          driver: mergeEquityPrice(
            action.payload,
            state.creditData.driver ?? [],
          ),
          impliedRating: state.creditData.impliedRating ?? [],
        },
      }
    case UPDATE_PRICES_CURRENCY:
      return {
        ...state,
        marketContext: {
          ...state.marketContext,
          currency: action.payload,
        },
      }
    case UPDATE_PRICE_LOADING:
      return {
        ...state,
        marketContext: {
          ...state.marketContext,
          priceLoading: action.loading,
        },
      }
    case UPDATE_EVENTS_LOADING:
      return {
        ...state,
        marketContext: {
          ...state.marketContext,
          eventLoading: action.loading,
        },
      }
    case UPDATE_EVENTS:
      return {
        ...state,
        marketContext: {
          ...state.marketContext,
          eventData: action.payload,
          eventLoading: false,
        },
      }
    case UPDATE_FUNDAMENTAL_CHARTS:
      return {
        ...state,
        fundamentalData: action.payload.result,
        showFundamentals: action.payload.showFundamentals,
      }
    case UPDATE_FUNDAMENTAL_LOADING:
      return {
        ...state,
        fundamentalLoading: action.loading,
      }
    case UPDATE_BEHAVIOR_CHART_LOADING:
      return {
        ...state,
        behaviorChartLoading: action.loading,
      }
    case UPDATE_SHOW_BEHAVIOUR_CHART:
      return {
        ...state,
        showBehavioural: action.loading,
      }
    case UPDATE_BOND_INVESTORS:
      return {
        ...state,
        behaviorData: {
          ...state.behaviorData,
          bondInvestors: action.payload,
        },
      }
    case UPDATE_HIGH_CONVICTION:
      return {
        ...state,
        behaviorData: {
          ...state.behaviorData,
          highConvictions: action.payload,
        },
      }
    case UPDATE_ESTIMATES:
      return {
        ...state,
        behaviorData: {
          ...state.behaviorData,
          estimates: action.payload,
        },
      }
    case SET_COMPANIES:
      return {
        ...state,
        companies: action.payload,
      }
    case PORTFOLIO_DATA:
      return {
        ...state,
        portfolioData: action.payload,
      }
    case SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      }
    case CURRENT_SCROLL_POSITION:
      return {
        ...state,
        currentScrollPosition: action.payload,
      }
    case SET_BOTTOM:
      return {
        ...state,
        bottom: action.payload,
      }
    case CLEAN_UP: {
      return {
        ...state,
        marketContext: {
          priceData: [],
          eventData: [],
          priceLoading: true,
          eventLoading: true,
          currency: null,
        },
        creditData: {
          pod: [],
          assetLeverage: [],
          assetVolatility: [],
          podCompare: {},
        },
        creditLoading: true,
        fundamentalData: [],
        fundamentalLoading: true,
        behaviorData: {
          estimates: [],
          bondInvestors: [],
          highConvictions: [],
        },
        behaviorChartLoading: true,
      }
    }
    case SET_SHOW_BEHAVIOURAL: {
      return {
        ...state,
        showBehavioural: action.payload,
      }
    }
    case SET_SHOW_PEER_TOGGLE: {
      return {
        ...state,
        showPeerToggle: action.payload,
      }
    }
    case SET_SHOW_COMPANY_TOGGLE: {
      return {
        ...state,
        showCompanyToggle: action.payload,
      }
    }
    case REMOVE_COMPANY: {
      const tickers = state.tickersInPortfolio.filter(
        (t: any) => t.ticker !== action.payload,
      )
      return {
        ...state,
        tickers,
      }
    }
    case UPDATE_CREDIT_PANEL_LOADING: {
      return {
        ...state,
        creditLoading: action.loading,
      }
    }
    case UPDATE_CREDIT_PANEL_DATA: {
      return {
        ...state,
        creditData: {
          pod: mergeEquityPrice(
            state.marketContext.priceData,
            action.payload.pod,
          ),
          driver: mergeEquityPrice(
            state.marketContext.priceData,
            action.payload.driver,
          ),
          impliedRating: action.payload.impliedRating,
        },
        showCreditChart: action.payload.showCreditChart,
      }
    }
    case UPDATE_CREDIT_DATA_COMPARISON: {
      return {
        ...state,
        creditData: {
          ...state?.creditData,
          podCompare: mergePodCompare(
            state?.creditData?.podCompare,
            action.payload.pod,
          ),
        },
      }
    }
    case DELETE_CREDIT_DATA_COMPARISON: {
      return {
        ...state,
        creditData: {
          ...state?.creditData,
          podCompare: deleteItemPodCompare(
            state.creditData?.podCompare,
            action.payload.itemDelete,
          ),
        },
      }
    }
    case UPDATE_NOTES_LOADING: {
      return {
        ...state,
        notesDataLoading: action.loading,
      }
    }
    case UPDATE_NOTES_DATA: {
      return {
        ...state,
        notesData: action.payload,
      }
    }
    case GET_WHAT_IF_LOADING: {
      return {
        ...state,
        whatIfLoading: action.loading,
      }
    }
    case GET_WHAT_IF_DATA: {
      return {
        ...state,
        whatIfData: {
          csm: action?.payload?.csm,
          ticker_type: action?.payload?.ticker_type,
          date: action?.payload?.date,
          ticker: action?.payload?.ticker,
          bfaiRating: action?.payload?.bfaiRating,
        },
        whatIfDataDetail: action?.payload?.data,
        whatIfDataDetailCalculate: {},
      }
    }
    case CALCULATE_WHAT_IF_LOADING: {
      return {
        ...state,
        whatIfCalculateLoading: action.loading,
      }
    }
    case CALCULATE_WHAT_IF_DATA: {
      if (action?.payload?.typeStage === 'stage2') {
        return {
          ...state,
          whatIfDataDetailCalculate: {
            ...state.whatIfDataDetailCalculate,
            scenario1_stage2_fields:
              action?.payload?.data?.scenario1_stage2_fields,
            what_if_box: action?.payload?.data?.what_if_box,
          },
          whatIfData: {
            ...state.whatIfData,
            csmCalculate2: action?.payload?.csmCalculate,
            bfaiCalculate2Rating: action?.payload?.bfaiRating ?? '',
          },
        }
      }
      return {
        ...state,
        whatIfDataDetailCalculate: action?.payload?.data,
        whatIfData: {
          ...state.whatIfData,
          csmCalculate: action?.payload?.csmCalculate,
          payloadOutput: action?.payload?.payloadOutput,
          bfaiCalculateRating: action?.payload?.bfaiRating ?? '',
        },
      }
    }
    case CLEAR_CALCULATE_WHAT_IF_DATA: {
      return {
        ...state,
        whatIfDataDetailCalculate: {},
        whatIfData: {
          ...state.whatIfData,
          csmCalculate: null,
          csmCalculate2: null,
          payloadOutput: null,
          bfaiCalculateRating: null,
          bfaiCalculate2Rating: null,
        },
      }
    }
    case SET_LOADING_ADD_DELETE_TICKER: {
      return {
        ...state,
        loadingAddDeleteTicker: action.loading,
      }
    }
    default:
      return state
  }
}
